import { LogWriter, Severity } from './logger.types';

export class ConsoleLogWriter implements LogWriter {
  write(severity: Severity, message: string, metadata: Record<string, unknown>): void {
    const label = `[${severity}]`;
    const logFn = this.getLogFunction(severity);

    logFn(label, message, metadata);
  }

  private getLogFunction(severity: Severity): (...args: unknown[]) => void {
    switch (severity) {
      case 'ERROR':
      case 'CRITICAL':
        return console.error;
      case 'WARNING':
        return console.warn;
      case 'DEBUG':
        return console.debug;
      default:
        return console.log;
    }
  }
}
